module.exports = __webpack_public_path__ + "static/media/igp_logo.fa958fa7.png";